import { NgModule } from '@angular/core';

import { CustomerActivityLogsComponent } from './customer.activity-logs.component';
import { CustomerTypePipe }              from './customer.type.pipe';
import { SharedModule }                  from '../shared/shared.module';
import { TableModule }                   from '../table/table.module';

@NgModule({
  declarations: [
    CustomerActivityLogsComponent,
    CustomerTypePipe
  ],
  entryComponents: [
    CustomerActivityLogsComponent
  ],
  imports: [
    SharedModule,
    TableModule
  ],
  providers: [
    CustomerTypePipe,

    // Pipes must also be provided via string
    // if they are going to be used in a table
    // column. This allows the injector to be
    // able to load a pipe dynamically in the
    // TableCellComponent.
    {
      provide : 'customerType',
      useClass: CustomerTypePipe
    }
  ]
})
export class CustomersModule {}
